<script lang="ts">
import { defineComponent, PropType, inject } from 'vue'
import StepWrapper from './StepWrapper.vue'

export default defineComponent({
  name: 'PositionLevelStep',

  components: {
    StepWrapper,
  },

  props: {
    namespace: {
      type: String,
      required: true,
    },

    positionLevel: {
      type: Object as PropType<InputText>,
      required: true,
    },
  },

  emits: ['update:positionLevel', 'click:prev', 'click:next'],

  setup(_, { emit }) {
    const POSITION_LEVELS = inject<string[]>('POSITION_LEVELS')!

    const next = () => {
      emit('click:next')
    }

    return {
      // constants
      POSITION_LEVELS,

      // methods
      next,
    }
  },
})
</script>

<template>
  <StepWrapper
    :namespace="namespace"
    :input-scheme="positionLevel"
    category-label="役職"
    :category-items="POSITION_LEVELS"
    @update:model-value="$emit('update:positionLevel', $event)"
    @click:prev="$emit('click:prev')"
    @click:next="$emit('click:next')" />
</template>
